const Securities = () => {
    return (
        <>
            <section>

            </section>
        </>
    )
}
export default Securities